import tempMeeApi from '../../../apis/tempMee';

// Every cycle crossed with one user's status, newest-created first, for the
// profile Promotion tab (GOTU-4819 / GOTU-5817). Cycles the user never entered
// come back as membershipStatus "not-entered". pageSize is fixed server-side
// at 15 and is not a parameter.
export const getUserCycles = async (userId, page = 1) => {
  const response = await tempMeeApi.get(
    `/awards-service-api/admin/users/${userId}/cycles`,
    { params: { page } },
  );

  return response.data;
};
